/**
 * Filter options for stream discovery.
 *
 * These options power the Filter Panel in the Home Dashboard,
 * allowing users to narrow down streams by various criteria.
 */

/**
 * Viewer settings toggles — control what viewer information is visible/enabled.
 */
export const VIEWER_SETTINGS = [
  { id: 'viewerPlatformDisplay', label: 'Enabled Viewer Platform Display', defaultChecked: false },
  { id: 'donationSharing', label: 'Enabled Donation Sharing', defaultChecked: false },
  { id: 'crossStreaming', label: 'Enabled Cross-Streaming', defaultChecked: false },
  { id: 'viewerSocials', label: 'Viewer Socials Displayed', defaultChecked: true },
];

/**
 * Streaming platforms for filtering.
 */
export const PLATFORM_OPTIONS = [
  { id: 'twitch', label: 'Twitch' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'tiktok', label: 'TikTok' },
  { id: 'instagram', label: 'Instagram' },
  { id: 'facebook', label: 'Facebook' },
  { id: 'x', label: 'X' },
  { id: 'kick', label: 'Kick' },
];

/**
 * Language options for filtering streams.
 */
export const LANGUAGE_OPTIONS = [
  { value: '', label: 'All Languages' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ru', label: 'Russian' },
  { value: 'zh', label: 'Chinese' },
];

/**
 * Slider configurations for numeric filters.
 */
export const SLIDER_CONFIGS = {
  duration: {
    min: 30,
    max: 600,
    step: 30,
    defaultValue: 30,
    formatLabel: (val) => val >= 600 ? 'Unlimited' : val < 60 ? `${val}s` : `${Math.floor(val / 60)}m`,
    unit: 'Seconds',
    minLabel: '30 Seconds',
    maxLabel: 'Unlimited',
  },
  views: {
    min: 0,
    max: 10000,
    step: 100,
    defaultValue: 7500,
    formatLabel: (val) => val >= 10000 ? '10,000+' : val.toLocaleString(),
    unit: 'views',
    minLabel: '0 Views',
    maxLabel: '10,000+ views',
  },
  donations: {
    min: 500,
    max: 1000000,
    step: 500,
    defaultValue: 1000000,
    formatLabel: (val) => val >= 1000000 ? '1,000,000+' : val.toLocaleString(),
    unit: 'tokens',
    minLabel: '500 Tokens',
    maxLabel: '1,000,000+ Tokens',
  },
};

/**
 * Default filter state — used when clearing filters.
 */
export const DEFAULT_FILTERS = {
  viewerSettings: VIEWER_SETTINGS.reduce((acc, opt) => {
    acc[opt.id] = opt.defaultChecked;
    return acc;
  }, {}),
  durationEnabled: false,
  durationValue: SLIDER_CONFIGS.duration.defaultValue,
  viewsEnabled: false,
  viewsValue: SLIDER_CONFIGS.views.defaultValue,
  donationsEnabled: false,
  donationsValue: SLIDER_CONFIGS.donations.defaultValue,
  platforms: {},
  language: '',
  tags: [],
};
